import React from 'react';
import { TooltipPosition } from '@progress/kendo-react-tooltip';
import cn from 'clsx';

import styles from './style.module.scss';
import { Icon } from '@components-clean/core/icons/icon';
import { useTranslation } from '@hooks/index';

type InvalidIconProps = {
    dataTestId: string;
    className?: string;
    tooltipPosition?: TooltipPosition;
    isSuffix?: boolean;
    toolTipText?: string | undefined;
    padding?: 'small' | 'regular' | 'none';
};

const InactiveIcon = ({
    dataTestId,
    className,
    tooltipPosition,
    isSuffix,
    toolTipText,
    padding = 'regular',
}: InvalidIconProps) => {
    const { t } = useTranslation();
    const classes = cn(styles.inactiveIcon, className);
    return (
        <Icon
            dataTestId={dataTestId}
            className={classes}
            title={toolTipText === undefined ? t('inactiveIcon') : toolTipText}
            icon={['fal', 'circle-xmark']}
            tooltipPosition={tooltipPosition}
            isInactive
            isSuffix={isSuffix}
            padding={padding}
        />
    );
};

export default InactiveIcon;
